import { createSlice } from '@reduxjs/toolkit'
import { fetchInitialLoad } from './fetchInitialLoad'
import { fetchParticipants } from '../users/fetchParticipants'
import { createThread } from '../messageThreads/createThread'
import { fetchMessages } from '../messages/fetchMessages'
import { addMessage } from '../messages/addMessage'
import { updateLastRead } from '../messages/updateLastRead'

const typePrefixToStateKey = (typePrefix) => {
  return typePrefix.split('/')[1]
}

const createAsyncStateHandlers = (builder, actions) => {
  actions.forEach((action) => {
    builder
      .addCase(action.pending, (state, actionMeta) => {
        const ownerId = actionMeta.meta.arg.unique_owner_id
        const stateKey = typePrefixToStateKey(action.typePrefix)

        state[ownerId] = state[ownerId] || {}
        state[ownerId].actionStatuses = state[ownerId].actionStatuses || {}
        state[ownerId].actionStatuses[stateKey] = state[ownerId].actionStatuses[stateKey] || {
          status: 'idle',
          loaded: false,
          error: null,
        }

        state[ownerId].actionStatuses[stateKey].status = 'fetching'
        state[ownerId].actionStatuses[stateKey].error = null
      })
      .addCase(action.fulfilled, (state, actionMeta) => {
        const ownerId = actionMeta.meta.arg.unique_owner_id
        const stateKey = typePrefixToStateKey(action.typePrefix)

        state[ownerId].actionStatuses = state[ownerId].actionStatuses || {}
        state[ownerId].actionStatuses[stateKey] = state[ownerId].actionStatuses[stateKey] || {}

        state[ownerId].actionStatuses[stateKey].status = 'success'
        state[ownerId].actionStatuses[stateKey].loaded = true
      })
      .addCase(action.rejected, (state, actionMeta) => {
        const ownerId = actionMeta.meta.arg.unique_owner_id
        const stateKey = typePrefixToStateKey(action.typePrefix)

        state[ownerId].actionStatuses = state[ownerId].actionStatuses || {}
        state[ownerId].actionStatuses[stateKey] = state[ownerId].actionStatuses[stateKey] || {}

        state[ownerId].actionStatuses[stateKey].status = 'failed'
        state[ownerId].actionStatuses[stateKey].error = actionMeta.payload || 'Something went wrong'
      })
  })
}


const initialState = { }

const ownerSlice = createSlice({
  name: 'owners',
  initialState,
  reducers: {
    setOwners(state, { payload }) {
      Object.entries(payload).forEach(([id, ownerData]) => {
        state[id] = { ...state[id], ...ownerData }
      })
    },

    setPagination(state, { payload: { id, data } }) {
      state[id].pagination = data
    },
    
    setAllowedParticipants(state, { payload: { id, data } }) {
      state[id] = { ...state[id], ...data}
    }
  },
  extraReducers: (builder) => {
    // add other handlers in array here
    createAsyncStateHandlers(builder, 
      [
        fetchInitialLoad, fetchParticipants, createThread, fetchMessages, addMessage, updateLastRead

      ])
  },
})

export const { setOwners, setPagination, setAllowedParticipants } = ownerSlice.actions
export default ownerSlice.reducer
